export default __webpack_public_path__ + "static/media/81.5d3404c8.png";